module.exports = __webpack_public_path__ + "1c98dd3db53fdccf70400a27238bc099.svg";